import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgInspSolution } from '../models/jg/jg-insp-solution.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class JgInspSolutionService extends RequestService<JgInspSolution> {
  static PATH = '/jg/inspSolution';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, JgInspSolutionService.PATH, globalService.debugUrl);
  }
}
